import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ShareKnowledge"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.25 18.75H15.75C14.5074 18.75 13.5 19.7574 13.5 21V22.5H15V21C15 20.5858 15.3358 20.25 15.75 20.25H20.25C20.6642 20.25 21 20.5858 21 21V22.5H22.5V21C22.5 19.7574 21.4926 18.75 20.25 18.75ZM15 15C15 16.6569 16.3431 18 18 18C19.6569 18 21 16.6569 21 15C21 13.3431 19.6569 12 18 12C16.3431 12 15 13.3431 15 15ZM19.5 15C19.5 15.8284 18.8284 16.5 18 16.5C17.1716 16.5 16.5 15.8284 16.5 15C16.5 14.1716 17.1716 13.5 18 13.5C18.8284 13.5 19.5 14.1716 19.5 15ZM4.5 15.75V15H3V15.75C3 18.6495 5.35051 21 8.25 21H10.5V19.5H8.25C6.17893 19.5 4.5 17.8211 4.5 15.75ZM14.25 7.5H19.5V9H14.25V7.5ZM14.25 4.5H21.75V6H14.25V4.5ZM14.25 1.5H21.75V3H14.25V1.5ZM8.25 8.25H3.75C2.50736 8.25 1.5 9.25736 1.5 10.5V12H3V10.5C3 10.0858 3.33579 9.75 3.75 9.75H8.25C8.66421 9.75 9 10.0858 9 10.5V12H10.5V10.5C10.5 9.25736 9.49264 8.25 8.25 8.25ZM6 7.5C7.65685 7.5 9 6.15685 9 4.5C9 2.84315 7.65685 1.5 6 1.5C4.34315 1.5 3 2.84315 3 4.5C3 6.15685 4.34315 7.5 6 7.5ZM6 3C6.82843 3 7.5 3.67157 7.5 4.5C7.5 5.32843 6.82843 6 6 6C5.17157 6 4.5 5.32843 4.5 4.5C4.5 3.67157 5.17157 3 6 3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ShareKnowledge.vue"]]);
